<template>

    <v-container class="fill-height" style="display: block;" fluid :class="{'widget-mode': $props.widgetMode}">

        <div class="no-license-text" v-if="!tableauEnabled">
            <p>
                You do not have a license for Telsasoft Cloud Dashboard. <br>
                Please visit <a style="color:#c42111;" href="https://telsasoft.com/dashboard/" target="_blank">here</a> for more information.
            </p>
        </div>


        <div v-if="tableauEnabled && !$props.widgetMode && !showCookieHelp">
            <div id="tableauViz"></div>
        </div>

        <div v-if="tableauEnabled && $props.widgetMode && !showCookieHelp">
            <div id="tableauViz" class="widget"></div>
        </div>

        
        <v-card id="cookie-help-message" v-if="showCookieHelp">
            <v-card-text>
                <span>ATTENTION: You need to allow 3rd party cookies for </span> 
                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <span style="font-weight: bold; text-decoration: underline; cursor: pointer;" v-on="on" @click="copyUrlToClipboard('[*.]telsasoft.com')">[*.]telsasoft.com</span>
                    </template>
                    <span>Copy to clipboard</span>
                </v-tooltip>
            </v-card-text>
        </v-card>
        
    </v-container>

</template>


<script>
import { TableauViz } from '@/assets/tableau';
export default {
    name: 'Dashboard',
    props: ['widgetMode', 'tableauUrl'],
    components: {

    },
    data: () => ({
        showClipboardSnackbar: false,
        clipboardSnackbarText: '',
        showCookieHelp: false
    }),

    computed: {
        tableauEnabled() {
            return !!this.$store.state.batchConfig.tableau;
        }

    },

    methods: {
        copyTableauUsername: function() {
            navigator.clipboard.writeText(this.$store.state.batchConfig.tableau.username);
            this.clipboardSnackbarText = "Username";
            this.showClipboardSnackbar = true;
        },
        copyTableauPassword: function() {
            navigator.clipboard.writeText(this.$store.state.batchConfig.tableau.password);
            this.clipboardSnackbarText = "Password";
            this.showClipboardSnackbar = true;
        },

        closeCreds: function() {
            this.$store.commit('displayTableauCreds', false);
        },

        getTableauAuthToken: function() {
            let route = (TELSA.apiHost + "dashboard/tableau/auth");
            TELSA.loading(true);
            return this.$http.post(route, {args: {user: this.$store.state.batchConfig.tableau.username}}).then(response => {
                let jwt = response.body;
                TELSA.loading(false);
                const viz = new TableauViz();
                viz.token = jwt;
                viz.toolbar = 'bottom';
                window.addEventListener("message", this.handleTableauMessage);
                if(this.$props.widgetMode) {
                    viz.src = this.$props.tableauUrl;
                }
                else {
                    viz.src = this.$store.state.batchConfig.tableau.link;
                }
                document.getElementById('tableauViz').appendChild(viz);
            });
        },

        handleTableauMessage: function(event) {
            if (event.data.name === "vizloaderror" && event.data.response.status == 401) {
                this.showCookieHelp = true;
            }
        },

        copyUrlToClipboard: function(url) {
            navigator.clipboard.writeText(url);
        }
    },

    mounted() {
        if(this.tableauEnabled) {
            this.getTableauAuthToken();
        }
    },

    destroyed() {
        window.removeEventListener("message", this.handleTableauMessage);
    }
};
</script>

<style scoped>

    .widget-mode {
        padding: 0px !important;
    }

    #tableauViz {
        width: 100%;
        height: calc(100vh - 85px);
        border: none;
    }

    #tableauViz.widget {
        height: 100%;
        border: solid 1px #ffffff;
    }

    #tableau-creds {
        position: absolute;
        border: solid black 1px;
        width: 400px;
        height: 190px;
        top: calc((100% - 190px) * .75);
        left: calc((100% - (12px + 400px)) / 2);
        padding: 5px 20px 5px 20px;
        border-radius: 10px;
        background-color: #C42114;
        box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
    }
    #tableau-creds .tableau-creds-label {
        display: block;
        font-size: 14pt;
        font-weight: 500;
        margin-bottom: 12px;
        margin-left: -4px;
    }
    #tableau-creds .tableau-creds-input {
        margin-bottom: -15px;
    }
    #tableau-creds .tableau-creds-close {
        position: absolute;
        right: 0px;
        top: 2px;
        cursor: pointer;
    }

    @media screen and (max-width: 600px) {
        #tableau-creds {
            width: 300px;
            height: 190px;
            top: calc((100% - 190px) * .75);
            left: calc((100% - (0px + 300px)) / 2);
        }
        #tableau-creds .tableau-creds-input {
            font-size: 10pt;
        }
    }

    #cookie-help-message {
        display: block;
        position: absolute;
        top: 200px;
        background-color: #c42111;
        border: solid 1px #ffffff;
        left: calc(50% - (470px / 2));
        z-index: 100;
    }
    #cookie-help-message span {
        color: #ffffff;
    }

</style>
